import React from 'react';
import styles from './DraggableElement.module.scss';
import PointsIcon from '@lmt/unicorn-shared/app/icons/ui-editor/points-vertical.svg?react';

export interface Props {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  onAction?: () => void;
  actionTitle?: string;
  testId?: string;
}

export const DraggableElement = React.forwardRef<HTMLDivElement, Props>(
  function DraggableElement(props, ref) {
    return (
      <div ref={ref} className={styles.container}>
        <div className={styles.element}>
          <PointsIcon className={styles.pointsIcon} />
        </div>
        {props.icon && (
          <div className={styles.element}>
            <div className={styles.elementIcon}>{props.icon}</div>
          </div>
        )}
        <div className={styles.element} data-test-id={props.testId}>
          <p className={styles.title}>{props.title}</p>
          {props.description && (
            <p className={styles.description}>{props.description}</p>
          )}
        </div>
        {props.actionTitle && props.onAction ? (
          <div className={styles.editButton} onClick={props.onAction}>
            {props.actionTitle}
          </div>
        ) : null}
      </div>
    );
  },
);
